import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class Foreclosures extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const records = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].foreclosures[0].foreclosure"
      );
      if (records) {
        _.forEach(records, (record, aircraftIndex) => {
          const recs = [];
          getAllRows(record, recs, props, _.get(record, "$.display"));
          if (recs.length > 0) {
            rows.push(
              <Table.Row key={`foreclosure_row_${aircraftIndex}`}>
                <Table.Cell>
                  <Table>
                    <Table.Body>
                      <Table.Row>
                        <Table.HeaderCell colSpan={2}>
                          Foreclosure
                        </Table.HeaderCell>
                      </Table.Row>
                      {recs}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
          }
        });
        recCount = rows.length;
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Foreclosures"}
        rows={this.state.rows}
      />
    );
  }
}

export default Foreclosures;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/Foreclosures.js